/**
 * The `syncedRef` key the report pages share so they open on the same date
 * range. It is scoped by restaurant and user so switching shops or users (in
 * the same browser or WebView) never leaks one selection into another session.
 *
 * The user id is part of the key because POS devices are shared. Without it,
 * one user's report selection can lock another user (notably staff, whose
 * available ranges are restricted) onto the wrong period.
 *
 * Kept in one place because every consumer must agree on the exact string.
 * Missing ids are simply omitted rather than persisted as `undefined`.
 */
const DEFAULT_BASE = "current_date";

export const sharedDateRangeKey = (
  restaurantId?: number | null,
  userId?: number | null,
  base: string = DEFAULT_BASE,
): string => {
  const parts = [base];
  if (restaurantId != null) parts.push(`restaurant:${restaurantId}`);
  if (userId != null) parts.push(`user:${userId}`);
  return parts.join(":");
};
